























import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import TableMenu from './Components/TableMenu.vue'
import Pagination from '@/app/ui/components/Pagination/index'
import { PositionDataModule } from '@/app/store/modules/position'

@Component({
  name: 'Position',
  components: {
    'top-menu': TopMenu,
    'table-menu': TableMenu,
    pagination: Pagination,
  },
})
export default class extends Vue {
  public searchInput = ''
  private selected = []

  public created() {
    this.getData()
  }

  public getData() {
    PositionDataModule.getPosition()
  }

  public get positionDataSfid(): any {
    return PositionDataModule.PositionData || []
  }
  public get positionDataDnet(): any {
    return PositionDataModule.PositionDataDnet || []
  }
  public get positionData() {
    const arr: any = this.positionDataDnet ? this.positionDataDnet.data : []
    for (const item of this.positionDataSfid
      ? this.positionDataSfid.data
      : []) {
      arr.push({
        id: item.id,
        code: item.code,
        description: item.description,
        storage: item.storage,
      })
    }
    return arr
  }

  public get isLoading() {
    return PositionDataModule.isLoading
  }
  public get fields() {
    return PositionDataModule.fields
  }

  private onPageNumChanged(limit: any) {
    this.getData()
  }

  private funcFirstPage() {
    this.getData()
  }

  private onRowSelected(items) {
    this.selected = items
  }
  public clearTableStatus: boolean = false
  public clearRowSelected() {
    this.selected = []
    if (this.clearTableStatus === false) {
      this.clearTableStatus = true
    } else {
      this.clearTableStatus = false
    }
  }
  public filter: string = ''
  private funcSearch(item) {
    this.filter = item
  }
}
